import {
  useRecoilStateLoadable,
  useRecoilValueLoadable,
  useSetRecoilState,
} from 'recoil';
import { numberToBuy } from '../../../recoil/atoms/numberToBuy';
import { buyPhoneNumber } from '../../../recoil/selectors/buyPhoneNumber';
import { refetchToggle } from '../../../recoil/selectors/makePHPRequest';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { ModalWithStyles } from './ModalWithStyles';
export function BuyAgentNumberModal(props) {
  const loading = useRecoilValueLoadable(buyPhoneNumber);
  const [, setNumberForm] = useRecoilStateLoadable(numberToBuy);
  function handleBuy() {
    setNumberForm({
      country: props.row.country,
      number: props.row.number,
      rate: props.row.monthly_rental_rate,
      numType: props.row.type,
    });
    setTimeout(() => {
      setRefetchToggleForAgentNumbers({});
      props.setRefetchToggleForNumbers?.({});
    }, 500);
    props.handleClose();
    props.closeOuterModal();
  }
  const setRefetchToggleForAgentNumbers = useSetRecoilState(
    refetchToggle(endpointEnum.GET_BUSINESS_DIDS)
  );
  return (
    <ModalWithStyles
      onSubmit={handleBuy}
      title={`Buy Number - ${props.row.number}`}
      aria-labelledby="example-modal-sizes-title-lg"
      show={props.show}
      onHide={() => props.handleClose()}
      isSubmitting={loading.state === 'loading'}
      isLoading={loading.state === 'loading'}
      size="xs"
    >
      <p>
        You are about to Buy the Number <b> {props.row.number}</b> for $
        {props.row.monthly_rental_rate} a month.
      </p>
      <p>Do you want to proceed?</p>
    </ModalWithStyles>
  );
}
